var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ViewProfileRemoveAccount"},[_c('app-button-control',{staticClass:"ViewProfileRemoveAccount__btn",attrs:{"type":"border-grey-light"},on:{"click":_vm.openRemoveAccountCurtain}},[_vm._v(" Удалить аккаунт ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }